import { call, put, select, takeEvery } from 'redux-saga/effects';
import { FetchSalesDistrictGoals, ISalesDistrictDealerGoal, salesAdminActionCreators, SalesAdminActionKeys } from '..';
import { IState } from '../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { getSalesDistricts } from '../../lookups/lookupsSelectors';
import { showFailedRequestDialog } from '../../sagaUtils';
import { fetchSalesDistrictGoals } from '../salesAdminApi';

function* fetchSalesDistrictGoalsSaga(action: FetchSalesDistrictGoals) {
  yield put(salesAdminActionCreators.toggleLoading('salesDistrictGoals'));
  const salesDists: string[] = yield select((state: IState) => getSalesDistricts(state, 'user'));

  const response: IApiExecuteRespone<ISalesDistrictDealerGoal[]> = yield call(
    fetchSalesDistrictGoals,
    action.payload.fiscalYear,
    salesDists
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(salesAdminActionCreators.setSalesDistrictGoals(response.value));
  }

  yield put(salesAdminActionCreators.toggleLoading('salesDistrictGoals'));
}

export function* watchFetchSalesDistrictGoals() {
  yield takeEvery(SalesAdminActionKeys.FETCH_SALES_DISTRICT_GOALS, fetchSalesDistrictGoalsSaga);
}
